<template>
    <div class="el-panel-widget f c-el-panel-bg br-m"
        :class="[
            `el--os-${outlineStyle}`,
            uiHasOutlineColor ? 'el--oc' : '',
            uiHasBackgroundColor ? 'el--bg' : '',
        ]"
        :style="{borderWidth: `${outlineWeight}px`, ...uiOutlineVars, ...uiBackgroundVars}">
        <slot name="content"></slot>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'mead-panel-widget',
    props: {
        /**
         * Width of the panel outline in pixels. Use 0 to hide the outline.
         */
        outlineWeight: {type: Number, default: 1},
        /**
         * Style of the panel outline. One of "solid", "dashed", "dotted" or "none".
         */
        outlineStyle: {
            type: String,
            default: 'solid',
            validator: value => ['solid', 'dashed', 'dotted', 'none'].includes(value),
        },
        /**
         * Color of the panel outline: a COLOR_STYLES value (e.g. "primary"), a tint of one
         * (e.g. "primary-20") or any CSS color (e.g. "#BAC3C4"). Defaults to the standard panel
         * border color when empty.
         */
        outlineColor: {type: String, default: ''},
        /**
         * Background color of the panel: a COLOR_STYLES value (e.g. "primary"), a tint of one
         * (e.g. "primary-20") or any CSS color (e.g. "#BAC3C4"). Styles also set a readable text
         * color. Defaults to the standard panel background when empty.
         */
        backgroundColor: {type: String, default: ''},
    },
    computed: {
        uiOutlineVars: function () {
            return MeadCommon.colorVars(this.outlineColor, {bg: '--panel-widget-outline'});
        },
        uiBackgroundVars: function () {
            return MeadCommon.colorVars(this.backgroundColor, {bg: '--panel-widget-bg', fg: '--panel-widget-fg'});
        },
        uiHasOutlineColor: function () {
            return Object.keys(this.uiOutlineVars).length > 0;
        },
        uiHasBackgroundColor: function () {
            return Object.keys(this.uiBackgroundVars).length > 0;
        },
    },
};
</script>
<style lang="scss">
@import '../../../sass/_variables.scss';
.el-panel-widget {
    max-width: 100%;
    overflow: hidden;
    box-shadow: var(--c-shade-s);
    border-color: var(--c-panel-border);

    @each $style in (solid, dashed, dotted, none) {
        &.el--os-#{$style} {
            border-style: $style;
        }
    }

    // Colors from the `outlineColor` and `backgroundColor` props. Each is only read with its class,
    // so a nested panel widget never picks up its parent's colors
    &.el--oc {
        border-color: var(--panel-widget-outline);
    }

    // Background from the `backgroundColor` prop, set as --panel-widget-bg/--panel-widget-fg
    &.el--bg {
        background-color: var(--panel-widget-bg);
        color: var(--panel-widget-fg, var(--c-txt));
    }
}
</style>
